import type { FC } from "react";

import { Arrange } from "@aviary";
import { SvgCarbonZeroLogo, SvgHipaaLogo } from "@shared/assets/images";
import { useSharedGlobalConfig } from "@shared/hooks";

import * as styles from "./FooterLogos.styles";

const FooterLogos: FC = () => {
  const { isUS } = useSharedGlobalConfig();

  return (
    <Arrange isWrapped={false} spacing="none" justify="center">
      <SvgCarbonZeroLogo />
      {isUS && <SvgHipaaLogo css={styles.spacingLeft} />}
    </Arrange>
  );
};

export { FooterLogos };
